import { SpotlightBannerItem } from "~/ProductDetails/ProductDetailPageResult";
import { sendGtmEvent } from "../definitions";

type CtrBannerTypes = "SideBySide" | "GoodBetterBest" | "CustomersAlsoViewed";

export type CtrEventProps = {
  destination?: string;
  source: string;
  type: CtrBannerTypes;
};

export const getDestinationItemNumber = (
  bannerType: CtrBannerTypes,
  item: SpotlightBannerItem
) => {
  if (bannerType === "SideBySide") {
    return item.compareProductItemNumber;
  }
  return item.itemNumber;
};

export const sendCtrEvent = (
  ctrEvent: "Click" | "Impression",
  ctrEventProps: CtrEventProps
) => {
  // @TODO: Follow up PBIs will be done for GBB will be done after CAV (#1271502)
  if (ctrEventProps.type === "GoodBetterBest") return;
  sendGtmEvent({
    event: "ClickThroughRate",
    ctrDestination: ctrEventProps?.destination ?? "",
    ctrType: ctrEventProps.type,
    ctrSource: ctrEventProps.source,
    ctrEvent: `ClickThroughRate${ctrEvent}`,
  });
};

export const onClickCtrTrack = (carouselName?: string, itemNumber?: string) => {
  if (!carouselName || !itemNumber) return;
  if (
    carouselName === "CustomersAlsoViewed" ||
    carouselName === "MiniCustomerAlsoViewed"
  ) {
    sendCtrEvent("Click", {
      type: "CustomersAlsoViewed",
      source: itemNumber,
    });
  }
};
